import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/case-documents/{formRequestTemplateId}']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const updateCaseDocument = async ({ formRequestTemplateId, castEid }: Input): Promise<ThisApi['response']> => {
  const data = await noodleApiClient.put(`/case-documents/${formRequestTemplateId}`, {
    castEid,
  });
  return data.data;
};

export default updateCaseDocument;
